/**
 * Read-only banner for the money / infrastructure / billing surfaces
 * (OCP-570) - the generalised `MailReadOnlyNotice` (OCP-545). One component
 * so the wording is identical on every page and a new page starts with the
 * same explanation.
 */
import { useTranslation } from 'react-i18next';

import { usePortalAccess, type PortalAccessScope } from '../lib/use-portal-access';

export function RoleReadOnlyNotice({ scope, className }: { scope: PortalAccessScope; className?: string }) {
  const { readOnlyReason } = usePortalAccess();
  const { t } = useTranslation('banners');
  const reason = readOnlyReason(scope);
  if (!reason) return null;
  return (
    <div
      role="status"
      data-testid={`role-read-only-notice-${scope}`}
      className={[
        'rounded-lg border border-amber-200 dark:border-amber-900/50 bg-amber-50 dark:bg-amber-900/30 px-3 py-2 text-sm text-amber-900 dark:text-amber-200',
        className ?? 'mb-4',
      ].join(' ')}
    >
      {reason} {t('readOnly.askAdmin')}
    </div>
  );
}
